module.exports = {
  FETCH_IMPC_WITH_MRD_REQUEST: 'FETCH_IMPC_WITH_MRD_REQUEST',
  FETCH_IMPC_WITH_MRD_SUCCESS: 'FETCH_IMPC_WITH_MRD_SUCCESS',
  FETCH_IMPC_WITH_MRD_FAILURE: 'FETCH_IMPC_WITH_MRD_FAILURE',
  FETCH_ALL_IMPC_SUCCESS: 'FETCH_ALL_IMPC_SUCCESS',
  FETCH_ALL_IMPC_FAILURE: 'FETCH_ALL_IMPC_FAILURE',
};
